// Constants for localStorage keys
export const KEYS = {
  LOGIN_TOKEN_STORE_KEY: 'access_token',
  REFRESH_TOKEN_KEY: 'refresh_token',
  CUSTOMER_ID_KEY: 'customer_id',
  TWO_FACTOR_TOKEN_KEY: 'two_factor_token',
  RESET_TOKEN_KEY: 'reset_token',
  KYC_STATUS_KEY: 'kyc_status',
} as const;
